import debug from 'bows';
import Citation from '../_citation';

const log = debug('article');

class Article {
	constructor(opts) {
		this.opts = opts;

		this.citations = Array.from( document.querySelectorAll( '.citation' ) ).map( ( node ) => new Citation( node ) );
		let articleCitation;

		if ( this.citations.length ) {
			articleCitation = this.citations.filter( ( cite ) => cite.node.classList.contains( 'article__citation' ) );
			if ( articleCitation.length ) {
				articleCitation = articleCitation.shift();
			}
		}

		let toggleCitation = document.querySelector( '.article__action--view-citation a' );
		if ( toggleCitation && articleCitation ) {
			toggleCitation.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				articleCitation.toggle();
			} );

			articleCitation.node.addEventListener( 'citation.open', () => {
				log( 'citation.open' );
				toggleCitation.classList.add( 'article__action--active' );
				toggleCitation.innerHTML = toggleCitation.innerHTML.replace( /\bView\b/, 'Hide' );
			} );

			articleCitation.node.addEventListener( 'citation.close', () => {
				log( 'citation.close' );
				toggleCitation.classList.remove( 'article__action--active' );
				toggleCitation.innerHTML = toggleCitation.innerHTML.replace( /\bHide\b/, 'View' );
			});
		}

		log(this);
	}
}

export default function( opts = {} ) {
	return new Article(opts);
}
